import type { LinkProps } from '@tanstack/react-router'
import {
  IconBuilding,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconFileText,
  IconFlag,
  IconFlask,
  IconListDetails,
  IconSettings,
  IconTemplate,
  IconUserCog,
  IconUserScreen,
  IconUsers,
} from '@tabler/icons-react'
import { type SidebarData } from '../layout/types'

export const adminSidebarData: SidebarData = {
  isLoading: false,
  user: {
    name: 'Admin User',
    email: 'admin@example.com',
    avatar: '/avatars/admin.jpg',
  },
  navGroups: [
    {
      title: 'Management',
      items: [
        {
          title: 'Organization Management',
          url: '/admin/organizations',
          icon: IconBuildingSkyscraper,
        },
        {
          title: 'Org Admin Management',
          url: '/admin/users',
          icon: IconUserCog,
        },
        {
          title: 'Tenant Management',
          url: '/admin/tenants',
          icon: IconBuildingSkyscraper,
        },
        {
          title: 'Agency Management',
          url: '/admin/agencies',
          icon: IconBuilding,
        },
        {
          title: 'Feature Flags',
          icon: IconFlag,
          items: [
            {
              title: 'Tenant Feature Flag Management',
              url: '/admin/feature-flags/tenant',
              icon: IconUsers,
            },
            {
              title: 'Overrides Tenant Feature',
              url: '/admin/feature-flags/tenant-overrides' as LinkProps['to'],
              icon: IconFlag,
            },
            {
              title: 'Common Feature Flag Management',
              url: '/admin/feature-flags/common',
              icon: IconBuildingWarehouse,
            },
            {
              title: 'Feature Management',
              url: '/admin/feature-management',
              icon: IconListDetails,
            },
          ],
        },
        {
          title: 'User Interface Configuration',
          url: '/admin/sdui',
          icon: IconUserScreen,
        },
        {
          title: 'Template Management',
          url: '/admin/templates' as LinkProps['to'],
          icon: IconTemplate,
        },
        {
          title: 'API Hub',
          icon: IconListDetails,
          items: [
            {
              title: 'Global API Credentials',
              url: '/admin/api-hub/global-credentials' as LinkProps['to'],
              icon: IconListDetails,
            },
          ],
        },
        {
          title: 'Business Configs',
          icon: IconSettings,
          items: [
            {
              title: 'Configurations',
              url: '/admin/business-config' as LinkProps['to'],
              icon: IconFileText,
            },
            {
              title: 'Test Config',
              url: '/admin/business-config/test' as LinkProps['to'],
              icon: IconFlask,
            },
          ],
        },
      ],
    },
  ],
}
